// Vehicle color name (as stored in DB) -> CSS hex
// Shared by AdminDrivers (form swatch) and SuperAdmin (route polyline color).
export const VEHICLE_COLORS = [
  { v: "White",   hex: "#f8f8f8" },
  { v: "Black",   hex: "#111111" },
  { v: "Silver",  hex: "#c0c0c0" },
  { v: "Gray",    hex: "#737373" },
  { v: "Red",     hex: "#d62828" },
  { v: "Blue",    hex: "#1d4ed8" },
  { v: "Green",   hex: "#234123" },
  { v: "Yellow",  hex: "#facc15" },
  { v: "Orange",  hex: "#FF6D00" },
  { v: "Brown",   hex: "#7c4a1e" },
];

export const VEHICLE_COLOR_HEX = Object.fromEntries(VEHICLE_COLORS.map((c) => [c.v, c.hex]));

export function vehicleColorHex(name) {
  if (!name) return null;
  return VEHICLE_COLOR_HEX[name] || null;
}
